import React, { useEffect, useState } from "react"
import { NavLink, useLocation } from "react-router-dom"

import data from "./data"
import MenuItem from "./MenuItem"
import Logo from "../../../assets/images/logo.png"
import * as Icons from "../../../assets/icons"
import { phone } from "../../../data/Contact"

const Menu = () => {
  const [open, setOpen] = useState(false)
  const [scrolled, setScrolled] = useState(false)
  const { pathname } = useLocation()

  useEffect(() => setOpen(false), [pathname])

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10)
    onScroll()
    window.addEventListener("scroll", onScroll, { passive: true })
    return () => window.removeEventListener("scroll", onScroll)
  }, [])

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : ""
  }, [open])

  return (
    <header className={`header ${scrolled ? "scrolled" : ""}`}>
      <div className="header-inner">
        <NavLink to="/" className="header-brand" aria-label="D&M Services – strona główna">
          <img src={Logo} className="header-logo" alt="Logo D&M Accountancy Services" />
          <span className="header-brand-text">
            <strong>D&M Services</strong>
            <small>Polskie biuro księgowe</small>
          </span>
        </NavLink>

        <nav className={`nav ${open ? "open" : ""}`} aria-label="Menu główne">
          <ul className="nav-list">
            {data.map((menuItem) => (
              <MenuItem key={menuItem.id} {...menuItem} />
            ))}
          </ul>
          <a href={phone.href} className="button button-primary nav-cta">
            <Icons.Phone /> {phone.display}
          </a>
        </nav>

        <button
          type="button"
          className={`nav-toggle ${open ? "open" : ""}`}
          onClick={() => setOpen(!open)}
          aria-expanded={open}
          aria-label={open ? "Zamknij menu" : "Otwórz menu"}
        >
          <span />
          <span />
          <span />
        </button>
      </div>
    </header>
  )
}

export default Menu
